import postal from 'postal';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import debounceAction from '../../shared/debounce-action';
import defaultOnErrorHandler from '../../shared/default-on-error-handler';
import ErrorBoundary from '../../shared/error-boundary';
import Loading from '../../shared/loading';
import assignWireCategory from '../../services/wire/category-service';
import { getAllCategories } from '../../services/categories-service';

export default class EditorsAssignCategoryModal extends React.Component {
  static propTypes = {
    onDismiss: PropTypes.func,
  };

  static defaultProps = {
    onDismiss: null,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      categories: [],
      wire: null,
      assignedCategoryId: null,
      show: false,
    };

    this.saveAssignedCategoryId = debounceAction({
      getCurrentValue: () => this.state.assignedCategoryId,
      actionPromise: () => assignWireCategory(
        this.state.wire.wire_id,
        this.state.assignedCategoryId,
      ),
      onBeforeAction: () => this.assignedCategoryIdLoading.start(),
      onError: e => defaultOnErrorHandler(e, 'Error updating assigned category'),
      onAfterAction: () => this.assignedCategoryIdLoading.stop(),
    });
  }

  componentDidMount() {
    postal.subscribe({
      channel: 'commands.categories',
      topic: 'assign-wire-category',
      callback: data => this.present(data.wire),
    });
  }

  handleAssignedCategoryChange(e) {
    const assignedCategoryId = e.target.value;

    this.setState({
      assignedCategoryId,
    }, () => this.saveAssignedCategoryId());
  }

  dismiss() {
    this.setState({ show: false });
    this.props.onDismiss && this.props.onDismiss();
  }

  present(wire) {
    this.setState({
      wire,
      assignedCategoryId: wire.category_id,
      show: true,
    }, () => {
      this.mainLoading.start();
      getAllCategories()
        .then(result => this.setState({ categories: result.data.categories }))
        .catch(e => defaultOnErrorHandler(e, 'Error loading categories'))
        .finally(() => this.mainLoading.stop());
    });
  }

  render() {
    return (
      <ErrorBoundary>
        <Modal
          centered="true"
          dialogAs="div"
          dialogClassName="editors-assign-category-modal"
          show={this.state.show}
          backdrop
          onHide={() => this.dismiss()}
        >
          <article>
            <header>
              <h4>Assign a Category</h4>
            </header>
            <Loading ref={el => (this.mainLoading = el)}>
              <section>
                <div className="btn-group">
                  {this.state.categories.map(category => (
                    <label
                      htmlFor={`category-${category.id}`}
                      className={`btn ${this.state.assignedCategoryId === category.id ? 'btn-secondary' : 'btn-default'}`}
                      key={category.id}
                    >
                      <input
                        id={`category-${category.id}`}
                        type="radio"
                        checked={this.state.assignedCategoryId === category.id}
                        onChange={e => this.handleAssignedCategoryChange(e)}
                        value={category.id}
                      />
                      {category.name}
                    </label>
                  ))}
                  <Loading variant="sip" ref={el => (this.assignedCategoryIdLoading = el)} />
                </div>
              </section>
              <footer>
                <button type="button" className="btn btn-primary" onClick={e => this.dismiss(e)}>Close</button>
              </footer>
            </Loading>
          </article>
        </Modal>
      </ErrorBoundary>
    );
  }
}
